import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { AgGridModule } from 'ag-grid-angular';
import { ActionsComponent } from './actions.component';
import { ActionsRoutingModule } from './actions-routing.module';
import { CreateComponent } from './components/create/create.component';
import { Trip2ThemeModule } from '../../trip2-theme/trip2-theme.module';
import { ActionsService } from './actions.service';
import { DirectivesModule } from '../../directives/directives.module';
import {TModulesService} from '../t-modules/t-modules.service';
import { T2LoadingService } from 'app/trip2-theme/components/t2-loading/t2-loading.service';

@NgModule({
  imports: [
    ActionsRoutingModule,
    AgGridModule,
    CommonModule,
    FormsModule,
    Trip2ThemeModule,
    DirectivesModule,
    ReactiveFormsModule,
  ],
  declarations: [ActionsComponent, CreateComponent],
  providers: [ActionsService, TModulesService, T2LoadingService]
})
export class ActionsModule { }



// WEBPACK FOOTER //
// ./src/app/pages/actions/actions.module.ts